export const encodeBase64 = (text = "") => {
  try {
    return btoa(unescape(encodeURIComponent(text))); 
  } catch {
    return "";
  }
};

export const decodeBase64 = (encoded = "") => {
  try {
    return decodeURIComponent(escape(atob(encoded)));
  } catch {
    return "";
  }
};
